import { useLocation,useNavigate } from "react-router-dom";
import React,{useState,useEffect } from 'react'
import apiClient from "../utils/axios";
import { ADMIN } from "../config/api";
import toast from "react-hot-toast";

function Addmenu() {
  const [formdata, setForm] = useState({ name:"",category: "",description:"", price: "" ,status:"",image: ""});
      const [errors, setErrors] = useState({});
      const [loading, setLoading] = useState(false);
      const [message, setMessage] = useState("");
      const token = localStorage.getItem("token");

          const navigate = useNavigate();
      
      const [categories, setCategories] = useState([]);

      const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const editId = queryParams.get("id"); // null = Add, string = Edit
    
      useEffect(() => {
  const fetchCategories = async () => {
    try {
      const { data } = await apiClient.get(ADMIN.GET_CATEGORY);
      if (Array.isArray(data.items)) {
        setCategories(data.items);
      } else {
        setCategories([]);
      }
    } catch (err) {
      console.error("Error fetching categories", err);
      toast.error(err.response?.data?.message || err.message || "Failed to fetch categories");
      setCategories([]);
    }
  };
  fetchCategories();
}, []);

useEffect(() => {
  if (!editId || categories.length === 0) return; // wait for categories to load

  const fetchMenuItem = async () => {
    try {
      const { data } = await apiClient.get(ADMIN.GET_MENU);
      if (data.success && Array.isArray(data.items)) {
        const item = data.items.find(m => m._id === editId);
        if (item) {
          setForm({
            name: item.name || "",
            category: item.category?._id || "",
            description: item.description || "",
            price: item.price || "",
            status: item.status || "",
            image: item.image ||"",
          });
        }
      }
    } catch (err) {
      console.error("Error fetching menu item", err);
      toast.error(err.response?.data?.message || err.message || "Failed to fetch menu item");
    }
  };

  fetchMenuItem();
}, [editId, categories]);  // ✅ Run when categories load



      const validate = () => {
        const e = {};
        if (!formdata.name || formdata.name.trim().length < 3)
          e.name = "Name must be at least 3 chars";
        if (!formdata.price || isNaN(formdata.price))
          e.price = "Valid price required";
        if (!formdata.category) e.category = "Category required";
        if (!formdata.status) e.status = "Status required";
        if (!editId && !formdata.image) e.image = "Image required";
        setErrors(e);
        return Object.keys(e).length === 0;
      };
    
      const formChangeData = (ev) => {
        const { name, value, files } = ev.target;
          if (name === "image") {
            setForm((f) => ({ ...f, image: files[0] }));  // save file object
          } else {
            setForm((f) => ({ ...f, [name]: value }));
          }
          setMessage("");
      };
    
      const handleSubmit = async (ev) => {
        ev.preventDefault();
        if (!validate()) return;

        setLoading(true);
        setMessage("");

        try {
          const formDataToSend = new FormData();
          Object.entries(formdata).forEach(([key, val]) => {
            if (val) formDataToSend.append(key, val);
          });

          const url = editId ? ADMIN.UPDATE_MENU(editId) : ADMIN.ADD_MENU;
          const method = editId ? "put" : "post";

          const { data } = await apiClient[method](url, formDataToSend, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });

          if (!data.success) throw new Error(data?.message || "Action failed");

          toast.success(data.message || (editId ? "Menu updated successfully" : "Menu added successfully"));
          setForm({ name:"", category:"", description:"", price:"", status:"", image:"" });

          setTimeout(() => {
            navigate("/menu");
          }, 1000);
        } catch (err) {
          toast.error(err.response?.data?.message || err.message || "Operation failed");
        } finally {
          setLoading(false);
        }
      };


  return (
    
    <div>
        
      <div className="col-12 grid-margin container-scroller" >
                <div className="card">
                  <div className="card-body" >
                    <h4 className="card-title"></h4>
                    <form method="post" onSubmit={handleSubmit} className="form-sample">
                      <p className="card-description"> Add Menu Item </p>
                      <div className="row">

                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Name</label>
                            <div className="col-sm-9">
                              <input type="text" name="name" value={formdata.name} onChange={formChangeData} className="form-control" />
                              {errors.name && <small className="text-danger">{errors.name}</small>}
                            </div>
                          </div>
                        </div>
                        
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Category </label>
                            <div className="col-sm-9">
                              <select
                                className="form-control"
                                name="category"
                                value={formdata.category}
                                onChange={formChangeData}
                              >
                                <option value="">-- Select Category --</option>
                                {categories.map((cat) => (
                                  <option key={cat._id} value={cat._id}>
                                    {cat.name}
                                  </option>
                                ))}
                              </select>
                              {errors.category && <small className="text-danger">{errors.category}</small>}
                            </div>
                          </div>
                        </div>
                      </div>

                        <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Discription</label>
                            <div className="col-sm-9">
                              <input type="text" name="description" value={formdata.description} onChange={formChangeData} className="form-control" />
                              {errors.description && <small className="text-danger">{errors.description}</small>}
                            </div>
                          </div>
                        </div>
                      
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Price</label>
                            <div className="col-sm-9">
                              <input className="form-control" name="price" value={formdata.price} onChange={formChangeData} />
                              {errors.price && <small className="text-danger">{errors.price}</small>}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Status</label>
                            <div className="col-sm-9">
                              <select className="form-control" name="status" value={formdata.status} onChange={formChangeData}>
                                <option value="">-- Select Status --</option>
                                <option value="Active">Active</option>
                                <option value="Deactive">Deactive</option>
                              </select>
                              {errors.status && <small className="text-danger">{errors.status}</small>}
                            </div>
                          </div>
                        </div>
                       <div className="col-md-6">
                          <label>Image</label>
                          <input type="file" name="image" onChange={formChangeData} className="form-control" />
                          {errors.image && <small className="text-danger">{errors.image}</small>}
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-12 text-center">
                            <button 
                              type="submit" 
                              className="btn btn-primary" 
                              >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
    </div>
  )
}

export default Addmenu
